// @ts-nocheck
import * as React from 'react';
import ChoosePlan from 'screens/EnrollCourse/ChoosePlan';
import { Icon } from './FreePlan.styles';
import type { FreePlanProps } from './FreePlan.types';

const FreePlan = ({
  university,
  onEnroll,
  onGetCertificate,
  cardTitle,
  courseTitle,
  sectionTitle,
  planDetails,
  showPlanSwitcher,
}: FreePlanProps) => (
  <ChoosePlan
    courseTitle={courseTitle}
    sectionTitle={sectionTitle}
    cardTitle={cardTitle}
    icon={<Icon />}
    price={0}
    type='free'
    onEnroll={onEnroll}
    subtitle={sectionTitle}
    onEnrollForFree={onGetCertificate}
    planDetails={planDetails}
    university={university}
    showPlanSwitcher={showPlanSwitcher}
  />
);

export default FreePlan;
